import React from 'react'
import styled from 'styled-components'

import useAuth from '../../hooks/use-auth'
import Iconify from '@/components/Iconify'
import { AUTH_STEPS } from '../../constants/auth-steps'
import { AUTH_NOTICE } from '../../constants/auth-notice'

const HIDE_AUTH_NOTICE_STEPS = [
  AUTH_STEPS.CLOSE_ANOTHER_SESSIONS,
  AUTH_STEPS.SMS_CONFIRMATION,
  AUTH_STEPS.COMPLETE_FACEBOOK_DATA,
  AUTH_STEPS.WELCOME_SUCCESS,
]

const NOTICE_CONFIG = {
  [AUTH_NOTICE.SESSION_EXPIRED]: {
    icon: 'material-symbols:warning-outline',
    message: 'Tú sesión ha expirado, puedes ingresar nuevemente',
  },
  [AUTH_NOTICE.LOGOUT_SUCCESS]: {
    icon: 'ri:logout-circle-line',
    message: 'Has cerrado sesión. ¡Vuelve pronto a Pickwin!',
  },
}

function resolveActiveNotice ({ isSessionExpired, authNotice, loginStatus }) {
  if (HIDE_AUTH_NOTICE_STEPS.includes(loginStatus)) return null

  if (isSessionExpired) return AUTH_NOTICE.SESSION_EXPIRED
  if (authNotice) return authNotice

  return null
}

export default function NotificationBar () {
  const { isSessionExpired, authNotice, closeAuthNotice, loginStatus } = useAuth()

  const activeNotice = resolveActiveNotice({ isSessionExpired, authNotice, loginStatus })
  const config = activeNotice ? NOTICE_CONFIG[activeNotice] : null
  const shouldShow = Boolean(config)

  const handleClose = (event) => {
    event.preventDefault()
    event.stopPropagation()
    closeAuthNotice()
  }

  if (!shouldShow) {
    return null
  }

  return (
    <Notification style={{ top: 0 }} aria-hidden={false}>
      <Iconify icon={config.icon} fontSize={17} color='#b8ff4d' />
      <span>{config.message}</span>
      <button type='button' onClick={handleClose} aria-label='Cerrar notificación'>
        <Iconify icon='mingcute:close-fill' />
      </button>
    </Notification>
  )
}

const Notification = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 5;
  width: 100%;
  height: 2em;
  background-color: #253f01;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: top 550ms ease-out;
  font-size: 1.05em;
  gap: 2em;
  text-shadow: 0 0 5px #00000064;
  pointer-events: auto;
  border-radius: 6px;
  box-shadow: 0 1px 10px #96ff0dff;

  & button {
    background-color: #00000032;
    outline: 0;
    border: 0;
    padding: 0;
    height: 2em;
    width: 2em;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.8em;
    cursor: pointer;
    flex-shrink: 0;

    &:hover {
      background-color: #00000064;
    }
  }
`
